import { render, staticRenderFns } from "./EmergeGoals.vue?vue&type=template&id=2469f196"
import script from "./EmergeGoals.vue?vue&type=script&lang=js"
export * from "./EmergeGoals.vue?vue&type=script&lang=js"
import style0 from "./EmergeGoals.vue?vue&type=style&index=0&id=2469f196&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports